// Legacy report paths that the generic `reports/:reportKey` route cannot match
// (they contain a slash). Every other legacy path (/reports/sales, /reports/time_clock,
// /reports/logs …) resolves through reportConfigs aliases.

import type { FeatureRoute } from '../registry';
import { ReportViewRoute } from '../../pages/ReportViewPage';

export const routes: FeatureRoute[] = [{ path: 'reports/items/top', element: <ReportViewRoute reportKey="top-items" /> }];
